import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Hook that listens for notification click events and navigates to the clicked chat.
 * Extracted from NovaProvider to simplify the main component.
 */
export function useNotificationClickNavigation(t0) {
  const $ = _c(4);
  const {
    onSelectChat,
    onOpenChat
  } = t0;
  let t1;
  let t2;
  if ($[0] !== onOpenChat || $[1] !== onSelectChat) {
    t1 = () => {
      const handleNotificationClick = event => {
        const customEvent = event as CustomEvent<{
          chatUuid: string;
          chatTitle: string;
        }>;
        const {
          chatUuid: clickedChatUuid
        } = customEvent.detail;
        if (clickedChatUuid) {
          onOpenChat();
          onSelectChat(clickedChatUuid);
        }
      };
      window.addEventListener("nova-chat-notification-click", handleNotificationClick);
      return () => {
        window.removeEventListener("nova-chat-notification-click", handleNotificationClick);
      };
    };
    t2 = [onSelectChat, onOpenChat];
    $[0] = onOpenChat;
    $[1] = onSelectChat;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
}